export const USER_AUTH_KEY = 'cocoan-auth-user';
export const USER_AUTH_TOKENS_KEY = 'cocoan-auth-tokens';
export const USER_AUTH_EVENT = 'cocoan-auth-user-login';
export const USER_AUTH_TOKENS_EVENT = 'cocoan-auth-user-tokens';

export interface AuthTokens{
	access: string,
	expires: number,
	refresh: string,
	refresh_expires: number,
}

export interface UserLogin{
	user: {
		user_id: number,
		email: string,
		first_name: string,
		last_name: string,
		superadmin: boolean,
		access?: number[],
		birthday?: number | null,
		gender_id?: number | null,
		email_confirmed: boolean,
	},
	change_password?: {
		admin: boolean,
		token: string,
	},
	tokens: AuthTokens
}